// extracted by mini-css-extract-plugin
export default {"product":"i0","image_carousel":"j0","main_gallery":"k0","personalized_badge":"l0","greens_badge":"m0","arrows":"n0","slide":"o0","thumbnail_gallery":"p0","swiper-slide":"q0","learn_more":"r0","product_info":"s0","description_wrapper":"t0","checklist":"u0","checklistItem":"v0","delivery_freq":"w0","tooltip_button":"x0","key_benefits":"y0","benefit_item":"z0","ingredients":"A0","ingredient_item":"B0","active_slide":"C0","benefits_list":"E0","checkmark":"F0"};
    if(module.hot) {
      // 1715091685027
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  